export * from '../../../design-tokens/dist/design-tokens-amalitech';
